import React, { Component, Fragment } from 'react'
import { GlgCheckbox, GlgSelect } from 'SharedComponents'
import { Row, Col } from 'react-flexbox-grid'
import PropTypes from 'prop-types'


class ChannelsComponent extends Component {

  constructor(props){
    super(props)

    this.state = {
      busySelect: false,
    }

    this.onFocus = this.onFocus.bind(this)
    this.refreshTemplatesList = this.refreshTemplatesList.bind(this)
    this.buildEditTemplatePath = this.buildEditTemplatePath.bind(this)
  }

  componentDidMount() {
    window.addEventListener('focus', this.onFocus)
  }

  componentWillUnmount() {
    window.removeEventListener('focus', this.onFocus)
  }

  onFocus() {
    this.refreshTemplatesList()
  }

  refreshTemplatesList() {
    this.setState({
      ...this.state,
      busySelect: true,
    }, () => {
      $.ajax({
        url: `/customers/${this.props.customerId}/marketing_campaigns/get_channels_templates`,
        type: 'GET',
        success: (response) => {
          new Promise((resolve) => {
            this.props.setChannelAllTemplates('email', response.emailTemplates)
            this.props.setChannelAllTemplates('textMessage', response.textMessageTemplates)
            resolve()
          }).then(() => {
            this.setState({
              ...this.state,
              busySelect: false,
            })
          })
        },
        error: () => {
          // eslint-disable-next-line no-console
          console.log('Error refreshTemplatesList')
        },
      })
    })
  }

  buildEditTemplatePath(templateIndexPath, channel){
    const templateId = this.props.channels[channel].template
    let path = `${templateIndexPath}/`
    path += templateId && templateId.length > 0 ? `${templateId}/edit` : 'new'
    return path
  }

  render(){
    const {
      channels: {
        email,
        textMessage,
      },
      customerCanTextMessage,
      toggleChannel,
      setChannelTemplate,
      manageEmailTemplatesPath,
      manageTextMessageTemplatesPath,
    } = this.props

    return <div className="channel-component"><Row className="add-margin-top-15"><Col xs={ 12 } className="revert-grid"><GlgCheckbox label={ window.I18n.t('marketing_campaigns.components.channels_component.email') } name="channels[email]" checked={email.checked} disabled={!customerCanTextMessage} onChange={toggleChannel('email', email.allTemplates.length > 0 ? email.allTemplates[0].value : '')} className="checkbox_label_left_align"></GlgCheckbox></Col></Row>{email.checked && <Row className="vertical-align add-margin-bottom-15"><Col xs={ 6 } sm={ 3 } md={2} className="add-padding-left-40"><span className="align-baseline">{ window.I18n.t('marketing_campaigns.components.channels_component.select_template') }</span></Col><Col xs={ 6 } sm={ 3 }><GlgSelect items={ email.allTemplates } searchable={ true } busy={this.state.busySelect} value={email.template} onChange={setChannelTemplate('email')}></GlgSelect></Col><Col xs={12} sm={ 6 } className="add-padding-left-40 match-dropdown-height"><a href={this.buildEditTemplatePath(manageEmailTemplatesPath, 'email')} target={'_blank'}><i className="gga-pencil-45-angle"></i>{ window.I18n.t('marketing_campaigns.components.channels_component.edit_template') }</a><span className="dot add-margin-left-5 add-margin-right-5">{ '\u2022' }</span><a href={ manageEmailTemplatesPath } target={'_blank'}>{ window.I18n.t('marketing_campaigns.components.channels_component.manage_templates', { channel: window.I18n.t('marketing_campaigns.components.channels_component.email') }) }</a></Col></Row>}{customerCanTextMessage && <Fragment><Row className="add-margin-bottom-5"><Col xs={ 12 } className="revert-grid"><GlgCheckbox label={ window.I18n.t('marketing_campaigns.components.channels_component.text_message') } name="channels[text_message]" checked={textMessage.checked} onChange={toggleChannel('textMessage', textMessage.allTemplates.length > 0 ? textMessage.allTemplates[0].value : '')}></GlgCheckbox></Col></Row>        {textMessage.checked && <Row className="vertical-align add-margin-bottom-15"><Col xs={ 6 } sm={ 3 } md={2} className="add-padding-left-40"><span className="align-baseline">{ window.I18n.t('marketing_campaigns.components.channels_component.select_template') }</span></Col><Col xs={ 6 } sm={ 3 }><GlgSelect items={ textMessage.allTemplates } value={ textMessage.template } searchable={ true } busy={ this.state.busySelect } onChange={ setChannelTemplate('textMessage') }></GlgSelect></Col><Col xs={12} sm={ 6 } className="add-padding-left-40 match-dropdown-height"><a href={this.buildEditTemplatePath(manageTextMessageTemplatesPath, 'textMessage')} target={'_blank'}><i className="gga-pencil-45-angle"></i>{ window.I18n.t('marketing_campaigns.components.channels_component.edit_template') }</a><span className="dot add-margin-left-5 add-margin-right-5">{ '\u2022' }</span><a href={ manageTextMessageTemplatesPath } target={'_blank'}>{ window.I18n.t('marketing_campaigns.components.channels_component.manage_templates', { channel: window.I18n.t('marketing_campaigns.components.channels_component.text_message') }) }</a></Col></Row>}</Fragment>}</div>
  }
}

ChannelsComponent.propTypes = {
  onChange: PropTypes.func,
  channels: PropTypes.shape({
    email: PropTypes.shape({
      checked: PropTypes.bool,
      template: PropTypes.string,
      allTemplates: PropTypes.array,
    }),
    textMessage: PropTypes.shape({
      checked: PropTypes.bool,
      template: PropTypes.string,
      allTemplates: PropTypes.array,
    }),
  }),
  toggleChannel: PropTypes.func.isRequired,
  setChannelTemplate: PropTypes.func.isRequired,
  setChannelAllTemplates: PropTypes.func.isRequired,
  manageEmailTemplatesPath: PropTypes.string.isRequired,
  manageTextMessageTemplatesPath: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  customerCanTextMessage: PropTypes.bool.isRequired,
}

export default ChannelsComponent
